import {
  FETCH_CONNECTION_RUN_STATUS,
  FETCH_CONNECTION_RUN_STATUS_SUCCESS,
  FETCH_CONNECTION_RUN_STATUS_FAILURE,
} from '../../store/types';

import {
  fetchConnectionRunStatus as fetchConnectionRunStatusApi,
} from '../../api';
import { fetchConnections, fetchingError, selectPeriod, selectConnection } from '../../../shared/store/actions';
import { errorNotification } from '../../../shared/store/notificationActions';


const fetchConnectionRunStatus = ({ period, connection }) => async dispatch => {
  const fetchConnectionRunStatusSuccess = runStatus => ({
    type: FETCH_CONNECTION_RUN_STATUS_SUCCESS,
    runStatus,
  });

  dispatch({
    type: FETCH_CONNECTION_RUN_STATUS,
  });

  try {
    if (!period || !connection) {
      return;
    }

    dispatch({
      type: FETCH_CONNECTION_RUN_STATUS,
    });

    const responseData = await fetchConnectionRunStatusApi({
      periodName: period.name,
      connection,
    });

    return dispatch(fetchConnectionRunStatusSuccess(responseData));
  } catch (error) {
    dispatch({
      FETCH_CONNECTION_RUN_STATUS_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchInitialDataForConnectionRunStatusPage = () => async (dispatch, getState) => {
  const { period } = getState().shared;

  await dispatch(fetchConnections(period, {
    includeAllOption: false,
    setConnection: false,
  }));

  const { connection, connections } = getState().shared;

  if (!connection) {
    await dispatch(selectConnection(connections[0].connName));
  }

  dispatch(fetchConnectionRunStatus({ period, connection: getState().shared.connection.connName }));
};

export const selectPeriodForConnectionRunStatus = period => async (dispatch, getState) => {
  dispatch(selectPeriod(period));

  await dispatch(fetchConnections(period));

  const state = getState();
  const { connection } = state.shared;

  return dispatch(fetchConnectionRunStatus({
    connection: connection.connName,
    period,
  }));
};

export const selectConnectionForConnectionRunStatus = connection => (dispatch, getState) => {
  dispatch(selectConnection(connection));

  const state = getState();
  const { period } = state.shared;

  return dispatch(fetchConnectionRunStatus({
    connection,
    period,
  }));
};
